"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformModelSharingApi = exports.SdPlatformModelharingQueryEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformModelharingQueryEmbeddableFields;
(function (SdPlatformModelharingQueryEmbeddableFields) {
    SdPlatformModelharingQueryEmbeddableFields["User"] = "user";
    SdPlatformModelharingQueryEmbeddableFields["Model"] = "model";
    SdPlatformModelharingQueryEmbeddableFields["Provider"] = "provider";
})(SdPlatformModelharingQueryEmbeddableFields = exports.SdPlatformModelharingQueryEmbeddableFields || (exports.SdPlatformModelharingQueryEmbeddableFields = {}));
/**
 * Operations for model sharing relationships.
 */
class SdPlatformModelSharingApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "model_sharing";
    }
    /**
     * Create a model sharing relationship.
     * @param body {@link SdPlatformRequestModelSharingCreate} body of a request with parameter to create sharing.
     * @returns the {@link SdPlatformPostResponse} response with {@link SdPlatformResponseModelSharing} as parameter.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.ModelSharingCreate, body);
    }
    /**
     * Create multiple sharings.
     * @param body {@link SdPlatformRequestModelSharingCreateMultiple}
     * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponseModelSharing} as result.
     */
    createMultiple(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.ModelSharingCreateMultiple, ResourcesApi_1.Action.Post, "model_sharing_multiple", body);
    }
    /**
     * Query model sharing relationships.
     * @param query {@link SdPlatformModelSharingQueryParameters}
     * @returns the {@link SdPlatformQueryResponse} response with {@see SdPlatformResponseModelSharing} as data result.
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.ModelSharingQuery, query);
    }
    /**
      * Query model sharing relationships by model id.
      * @param model_id
      * @param query {@link SdPlatformModelSharingQueryParameters}
      * @returns the {@link SdPlatformQueryResponse} response with {@see SdPlatformResponseModelSharing} as data result.
      */
    queryByModel(model_id, query = {}) {
        return super.__action(SdPlatformRequestId_1.RequestId.ModelSharingQueryByModel, ResourcesApi_1.Action.Post, `model/${model_id}/query`, query);
    }
    /**
     * Query model sharing relationships by user id.
     * @param user_id
     * @param query  {@link SdPlatformModelSharingQueryParameters}
     * @returns the {@link SdPlatformQueryResponse} response with {@see SdPlatformResponseModelSharing} as data result.
     */
    queryByUser(user_id, query = {}) {
        return super.__action(SdPlatformRequestId_1.RequestId.ModelSharingQueryByUser, ResourcesApi_1.Action.Post, `user/${user_id}/query`, query);
    }
    /**
     * Get model sharing relationships by model id and user id.
     * @param model_id
     * @param user_id
     * @returns the {@link SdPlatformGetResponse} response with {@see SdPlatformResponseModelSharing} as data result.
     */
    getByModelAndUser(model_id, user_id) {
        return super.__get(SdPlatformRequestId_1.RequestId.ModelSharingGetByModelAndUser, `model/${model_id}/user/${user_id}`);
    }
    /**
     * Delete a model sharing relationship.
     * @param model_sharing_id Id of the model sharing relationship to delete.
     * @returns
     */
    delete(model_sharing_id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.ModelSharingDelete, model_sharing_id);
    }
    /**
     * Gets the model sharings grouped by user.
     * @param model_id
     * @returns
     */
    getGroupedByUser(model_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.ModelSharingGroupedByuser, ResourcesApi_1.Action.Get, `model/${model_id}/grouped_by_user`, {});
    }
    /**
     * Copy model sharings from one model to another.
     * @param from_model_id
     * @param to_model_id
     */
    copyModelSharings(from_model_id, to_model_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.ModelSharingCopy, ResourcesApi_1.Action.Post, `model/${to_model_id}/copy`, {
            "model_id": from_model_id
        });
    }
}
exports.SdPlatformModelSharingApi = SdPlatformModelSharingApi;
//# sourceMappingURL=SdPlatformModelSharingApi.js.map